/* eslint-disable react-hooks/exhaustive-deps */
import { type RefObject, useEffect } from 'react'

export function useScrollToBottom(
	ref: RefObject<HTMLElement>,
	dependencies: any[],
) {
	useEffect(() => {
		if (ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth' })
		}
	}, dependencies)
}
